import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { createQueryClient } from "./pwa";
import { Application } from "./shell/Application";
import "./styles.css";

const root = document.getElementById("root");

if (root === null) {
  throw new Error("Application root element is missing");
}

const queryClient = createQueryClient();

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Application />
    </QueryClientProvider>
  </StrictMode>,
);
